import "bootstrap/dist/css/bootstrap.min.css";
import Aboutussec from "./image/about-img.png";
import about from "./image/abt-img.jpg";
import about1 from "./image/about1.png";
import about2 from "./image/about2.png";
import about3 from "./image/about3.png";
import about4 from "./image/about4.png";
import about5 from "./image/about5.png";
import about6 from "./image/about6.png";

import AOS from "aos";
import "aos/dist/aos.css";

import "./about.css";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
function About() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    AOS.init({
      once: false,
      disable: "phone",
      duration: 1000,
      easing: "ease-out-cubic",
    });
  }, []);
  return (
    <>
      <div className="about_section">
        <img width="100%" height="500px" src={Aboutussec} className="img-fluid" alt="..." />
      </div>

      <div className="container-fluid about-page">
        <div className="container">
          <div className="row">
            <div data-aos="fade-up" className="col-lg-6">
              <div data-aos="fade-left" className="about-page-1">
                <h3 className="recent-title" >About Us</h3>
                <p>
                 At RealThink Technology, we’re a team of passionate developers, designers, and digital strategists committed to delivering full stack development and artificial intelligence solutions. Based in Bhopal, India,
                  <p>
                    we specialize in React.js development, Node.js back‑end services, and Python machine learning. Our mission is to help businesses scale by building robust web and mobile applications, deploying intelligent automation, and crafting data‑driven marketing campaigns.
                  </p>
                  <p>We offers cutting‑edge Full Stack Development, MERN Stack Training, AI Solutions, and Digital Marketing Services. Join our expert-led courses or hire top developers for React.js, Node.js, Python, and more.

</p>
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div  data-aos="fade-right" className="about-img-1">
                <img
                 
                  src={about}
                  alt="erty"
                  style={{ width: "100%" }}
                ></img>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="container-fluid about-page ">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 h1style">
              <h1>What Sets Us Apart</h1>
            </div>
            <div className="col-lg-4">
              <div className="apart-section-1">
                <img
                  src={about1}
                  alt="fghj"
                  style={{ width: "100%", height: "200px" }}
                ></img>
                <h4>Expertise</h4>
                <p>
                  With years of industry experience and a deep understanding of
                  the latest technologies and trends, our team brings expertise
                  and creativity to every project we undertake.
                </p>
              </div>
            </div>
            <div className="col-lg-4 ">
              <div className="apart-section-1">
                <img
                  src={about2}
                  alt="fg"
                  style={{ width: "100%", height: "200px" }}
                ></img>
                <h4>Collaborative Approach</h4>
                <p>
                  We believe in collaboration and communication. From initial
                  consultation to final delivery, we work closely with our
                  clients to ensure their vision is brought to life with
                  precision and excellence.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="apart-section-1">
                <img
                  src={about3}
                  alt="1223"
                  style={{ width: "100%", height: "200px" }}
                ></img>
                <h4>Tailored Solutions</h4>
                <p>
                  We understand that one size does not fit all. That's why we
                  take the time to understand each client's objectives, target
                  audience, and industry landscape to create bespoke solutions
                  that drive results.
                </p>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="apart-section-1">
                <img
                  src={about4}
                  alt="fgh"
                  style={{ width: "100%", height: "200px" }}
                ></img>
                <h4>Quality Assurance</h4>
                <p>
                  Quality is at the forefront of everything we do. Our rigorous
                  quality assurance processes ensure that every website we
                  deliver meets the highest standards of performance,
                  functionality, and security.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="apart-section-1">
                <img
                  src={about5}
                  alt=""
                  style={{ width: "100%", height: "200px" }}
                ></img>
                <h4>Customer Satisfaction</h4>
                <p>
                  Our commitment to customer satisfaction is unwavering. We
                  prioritize transparency, responsiveness, and reliability to
                  ensure our clients have a positive and rewarding experience
                  working with us.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="apart-section-1">
                <img
                  src={about6}
                  alt=""
                  style={{ width: "100%", height: "200px" }}
                ></img>
                <h4>Innovative Solutions</h4>
                <p>
                  We don't just follow trends; we set them. Our team is
                  constantly exploring new technologies, methodologies, and
                  strategies to develop innovative solutions that address the
                  evolving needs of our clients.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div data-aos="fade-up" className="service-section">
        <div className="container-fluid">
          <div class="container">
            <div class="row justify-content-center ">
              <div class="col-lg-12 text-center mb-10 ">
                <h2 className="recent-title ">What Sets Us Apart</h2>
              </div>
              <div
                data-aos="fade-right"
                class="col-lg-4 col-md-5 col-sm-6 mb-2"
              >
                <div class="card ">
                  <div class="card-body">
                    <img
                      className="card_img"
                      height="180px"
                      src={about1}
                      alt="..."
                    />
                    <h4 class="mt-4 mb-3 apart_heading ">Expertise</h4>
                    <p>
                      With years of industry experience and a deep understanding
                      of the latest technologies and trends, our team brings
                      expertise and creativity to every project we undertake.
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-aos="fade-right"
                class="col-lg-4  col-md-5 col-sm-6 mb-2"
              >
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={about2} alt="..." />
                    <h4 class="mt-4 mb-3 apart_heading ">
                      Collaborative Approach
                    </h4>
                    <p>
                      We believe in collaboration and communication. From
                      initial consultation to final delivery, we work closely
                      with our clients to ensure their vision is brought to life
                      with precision and excellence.
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="flip-up" class="col-lg-4  col-md-5 col-sm-6 mb-2">
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={about3} alt="..." />
                    <h4 class="mt-4 mb-3 apart_heading ">Tailored Solutions</h4>
                    <p>
                      We understand that one size does not fit all. That's why
                      we take the time to understand each client's objectives,
                      target audience, and industry landscape to create bespoke
                      solutions that drive results.
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-aos="flip-down"
                class="col-lg-4  col-md-5 col-sm-6 mb-2"
              >
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={about4} alt="..." />
                    <h4 class="mt-4 mb-3 apart_heading ">Quality Assurance</h4>
                    <p>
                      Quality is at the forefront of everything we do. Our
                      rigorous quality assurance processes ensure that every
                      website we deliver meets the highest standards of
                      performance, functionality, and security.
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-aos="fade-right"
                class="col-lg-4  col-md-5 col-sm-6 mb-2"
              >
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={about5} alt="..." />
                    <h4 class="mt-4 mb-3 apart_heading ">
                      Customer Satisfaction
                    </h4>
                    <p>
                      Our commitment to customer satisfaction is unwavering. We
                      prioritize transparency, responsiveness, and reliability
                      to ensure our clients have a positive and rewarding
                      experience working with us.
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-aos="fade-right"
                class="col-lg-4  col-md-5 col-sm-6 mb-2"
              >
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={about6} alt="..." />
                    <h4 class="mt-4 mb-3 apart_heading ">
                      Innovative Solutions
                    </h4>
                    <p>
                      We don't just follow trends; we set them. Our team is
                      constantly exploring new technologies, methodologies, and
                      strategies to develop innovative solutions that address
                      the evolving needs of our clients.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div className="main-section1">
        <div className="container-fluid">
          <div class="container">
            <div class="row">
            <div className="col-lg-12 vlog">
                <h1 data-aos="fade-up" className="recent-title text-center">
                Frequently Asked questions
                </h1>
              </div>
              <div class="faq-container">
    <div class="faq-item">
      <div class="faq-question">
      Where is RealThink Technology located?
        <span class="arrow">▶</span>
      </div>
      <div class="faq-answer">
      We are based in Bhopal, Madhya Pradesh, India, and offer both offline and online services to clients and learners across India and beyond.


      </div>
    </div>
    <div class="faq-item">
      <div class="faq-question">
      Do you offer custom website or app development?
        <span class="arrow">▶</span>
      </div>
      <div class="faq-answer">
        Absolutely! We specialize in custom software, websites, and mobile apps based on your business goals, features, and branding needs.


      </div>
    </div>
    <div class="faq-item">
      <div class="faq-question">
      Can you help me promote my business online?
        <span class="arrow">▶</span>
      </div>
      <div class="faq-answer">
      Definitely! Our Digital Marketing team can handle everything from SEO, Google Ads, and social media marketing to email campaigns and branding strategies.


      </div>
    </div>
  </div>



            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default About;
